const e=async(e,t,n,r)=>{await e.post(`/orgs/${n}/apps/${t}/users`,r)};export{e as assignOrgAppUser};
//# sourceMappingURL=assign-org-app-user.mjs.map